export enum FamilyQualityLife{
    secured,
    needy,
    childDisabilities,
    refugee
}

export const qualityLifes: any[] = [
  { id: 0, name: 'Обеспеченная' },
  { id: 1, name: 'Малообеспеченная' },
  { id: 2, name: 'Семья с ребенком ОВЗ' },
  { id: 3, name: 'Семья беженцев' }
];